import { motion, AnimatePresence } from 'framer-motion';
import { RefreshCw, X, ArrowUpCircle } from 'lucide-react';
import { useUpdateDetection } from '../hooks/useUpdateDetection';
import { useState } from 'react';

/**
 * UpdatePrompt Component
 * Elegant banner to notify users of available updates.
 * Matches Kaptura's architecture and visual polish.
 */
export function UpdatePrompt() {
  const { updateAvailable, applyUpdate } = useUpdateDetection();
  const [dismissed, setDismissed] = useState(false);

  // If no update or user dismissed it in this session, show nothing
  if (!updateAvailable || dismissed) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        className="fixed bottom-6 left-4 right-4 z-[9999] flex justify-center pointer-events-none"
      >
        <div className="bg-zinc-900/95 backdrop-blur-xl border border-emerald-500/30 p-1.5 pl-4 rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] flex items-center justify-between gap-4 max-w-sm w-full pointer-events-auto">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-emerald-500/20 text-emerald-400 flex items-center justify-center shrink-0">
              <ArrowUpCircle size={18} className="animate-pulse" />
            </div>
            <div className="flex flex-col">
              <span className="text-[10px] font-black uppercase tracking-widest text-emerald-400">Actualización</span>
              <span className="text-[11px] font-bold text-zinc-100 -mt-0.5 whitespace-nowrap">Nueva versión de VerbO disponible</span>
            </div>
          </div>

          <div className="flex items-center gap-1">
            <button
              onClick={applyUpdate}
              className="bg-emerald-500 hover:bg-emerald-400 text-zinc-950 px-3 py-2 rounded-xl font-black text-[10px] uppercase tracking-tighter flex items-center gap-2 transition-all active:scale-95 whitespace-nowrap"
            >
              <RefreshCw size={12} className="animate-spin-slow" />
              Actualizar ahora
            </button>
            <button
              onClick={() => setDismissed(true)}
              className="p-2 text-zinc-500 hover:text-zinc-300 transition-colors"
              title="Más tarde"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
